<ca-modal-container
    [modalTitle]="'APPLICATIONS.PUBLISH_CUSTOMIZED_APPLICATION.EDIT_TITLE' | translate"
    (dismiss)="dismiss()"
    data-uit="publish-application-dialog"
>
    <form [formGroup]="formGroup" novalidate (ngSubmit)="submit()">
        <div class="border-bottom">
            <div class="d-flex flex-column-reverse">
                <input
                    id="applicationName"
                    name="applicationName"
                    class="form-control"
                    formControlName="applicationName"
                    data-uit="publish-application-name"
                    required
                    [placeholder]="'APPLICATIONS.PUBLISH_CUSTOMIZED_APPLICATION.NAME_PLACEHOLDER' | translate"
                    [ngClass]="formGroup.get('applicationName')?.errors && formGroup.get('applicationName')?.dirty ? 'has-error' : ''"
                />
                <label class="mt-4" for="applicationName"
                    >{{ 'APPLICATIONS.PUBLISH_CUSTOMIZED_APPLICATION.NAME' | translate }}<span class="ms-1 red">*</span></label
                >
            </div>
            <small *ngIf="formGroup.get('applicationName')?.dirty && formGroup.get('applicationName')?.hasError('required')" class="invalid-feedback">
                {{ 'GENERAL.REQUIRED_FIELD' | translate }}
            </small>
            <div class="d-flex flex-column-reverse">
                <input
                    id="summary"
                    name="summary"
                    class="form-control"
                    formControlName="summary"
                    data-uit="publish-application-summary"
                    required
                    [placeholder]="'APPLICATIONS.PUBLISH_CUSTOMIZED_APPLICATION.DESCRIPTION_PLACEHOLDER' | translate"
                    [ngClass]="formGroup.get('summary')?.errors && formGroup.get('summary')?.dirty ? 'has-error' : ''"
                />
                <label class="mt-4" for="summary">{{ 'APPLICATIONS.PUBLISH_CUSTOMIZED_APPLICATION.SUMMARY' | translate }}<span class="ms-1 red">*</span></label>
            </div>
            <small *ngIf="formGroup.get('summary')?.dirty && formGroup.get('summary')?.hasError('required')" class="invalid-feedback">
                {{ 'GENERAL.REQUIRED_FIELD' | translate }}
            </small>
            <div class="d-flex flex-column-reverse form-group">
                <ca-quill-editor-wrapper
                    id="description"
                    formControlName="description"
                    [placeholder]="'APPLICATIONS.PUBLISH_CUSTOMIZED_APPLICATION.DESCRIPTION_PLACEHOLDER' | translate"
                    [required]="true"
                    data-uit="publish-application-description"
                    [ngClass]="formGroup.get('description')?.dirty && formGroup.get('description')?.errors ? 'has-error' : ''"
                ></ca-quill-editor-wrapper>
                <label class="mt-4" for="description"
                    >{{ 'APPLICATIONS.PUBLISH_CUSTOMIZED_APPLICATION.DESCRIPTION' | translate }}<span class="ms-1 red">*</span></label
                >
            </div>
            <small *ngIf="formGroup.get('description')?.dirty && formGroup.get('description')?.hasError('required')" class="invalid-feedback">
                {{ 'GENERAL.REQUIRED_FIELD' | translate }}
            </small>
            <div class="d-flex flex-column-reverse form-group">
                <ca-quill-editor-wrapper
                    id="requirements"
                    name="requirements"
                    formControlName="requirements"
                    data-uit="publish-application-requirements"
                    [placeholder]="'APPLICATIONS.PUBLISH_CUSTOMIZED_APPLICATION.REQUIREMENTS_PLACEHOLDER' | translate"
                    [required]="true"
                    [ngClass]="formGroup.get('requirements')?.dirty && formGroup.get('requirements')?.errors ? 'has-error' : ''"
                ></ca-quill-editor-wrapper>
                <label class="mt-4" for="requirements"
                    >{{ 'APPLICATIONS.PUBLISH_CUSTOMIZED_APPLICATION.REQUIREMENTS' | translate }}<span class="ms-1 red">*</span></label
                >
            </div>
            <small *ngIf="formGroup.get('requirements')?.dirty && formGroup.get('requirements')?.hasError('required')" class="invalid-feedback">
                {{ 'GENERAL.REQUIRED_FIELD' | translate }}
            </small>
            <ng-container *ngIf="application != null">
                <div class="d-flex flex-column-reverse">
                    <div class="d-flex" *ngFor="let measurement of displayMeasurements">
                        <ca-input-checkbox
                            class="me-1"
                            [checked]="measurement.selected"
                            (change)="toggleMeasurement(measurement)"
                            data-uit="measurement-checkbox"
                            >{{ measurement.child.name }}</ca-input-checkbox
                        ><ca-icon
                            *ngIf="measurement.child.description"
                            name="info"
                            size="s"
                            class="ca-color-icon-info info-icon"
                            [removeSVGAttributes]="['stroke']"
                            [ngbTooltip]="measurement.child.description"
                        ></ca-icon>
                    </div>
                    <label class="mt-4">{{ 'APPLICATIONS.CREATE_APPLICATION_DIALOG.SELECT_MEASUREMENTS' | translate }}</label>
                </div>

                <div class="d-flex align-items-center mt-3">
                    <span>{{ 'APPLICATIONS.CREATE_APPLICATION_DIALOG.LOOKING_FOR_DIFFERENT_MEASUREMENT' | translate }}</span>
                    <button type="button" class="btn btn-ghost ps-2 pe-1 py-0 ms-1 btn-request-measurement underline" (click)="requestMlMeasurement()">
                        {{ 'APPLICATIONS.CREATE_APPLICATION_DIALOG.SEND_MEASUREMENT_REQUEST' | translate
                        }}<ca-icon class="ms-2" name="envelope" size="s"></ca-icon>
                    </button>
                </div>
                <div class="position-relative ng-select-wrapper">
                    <div class="d-flex flex-column-reverse form-group">
                        <ng-select
                            tabindex="0"
                            [items]="models"
                            name="selectedModel"
                            formControlName="selectedModel"
                            appendTo="body"
                            appendTo=".ng-select-wrapper"
                            [placeholder]="'APPLICATIONS.CREATE_APPLICATION_DIALOG.SELECT_NEW_TRAINING_MODEL_PLACEHOLDER' | translate"
                            bindLabel="name"
                            [searchable]="true"
                            [clearable]="false"
                            data-uit="ml-model-selector"
                        >
                            <ng-template ng-label-tmp let-model="item"> {{ model.name }} ({{ model.createdAt | date: 'dd.MM.yyyy | hh:mm:ss' }}) </ng-template>
                            <ng-template ng-option-tmp let-model="item">
                                <div class="d-flex align-items-center justify-content-between" style="justify-content: space-between">
                                    {{ model.name }} ({{ model.createdAt | date: 'dd.MM.yyyy | hh:mm:ss' }})
                                    <div class="me-4">
                                        {{ !isUserOwner(model.userId) ? ('MY_WORKSPACE.MY_RESULTS.SHARING.MODULE_SELECTION_ADDITION' | translate) : '' }}
                                    </div>
                                </div>
                            </ng-template>
                        </ng-select>
                        <label class="mt-4" for="selectedModel">{{ 'APPLICATIONS.PUBLISH_CUSTOMIZED_APPLICATION.NEW_ML_MODEL' | translate }}</label>
                    </div>
                </div>
            </ng-container>
            <div>
                <div
                    caApeerFileUpload
                    data-uit="publish-application-thumb-file-upload"
                    [blobType]="blobType"
                    [maxInputSizeInBytes]="maxFileSizeInBytes"
                    [pathToAppend]="pathToAppend"
                    [supportedFileTypes]="supportedImageTypes"
                    [uploaderKey]="uploaderThumbKey"
                    [errorNotificationMode]="'notification'"
                    (onUploadCompleted)="onThumbUploadCompleted($event)"
                    (onUploadStarted)="onThumbUploadStarted()"
                >
                    <button type="button" class="btn btn-secondary w-100 my-4" [disabled]="isThumbUploading" (click)="uploadThumbSection.click()">
                        <ca-icon name="upload" size="s"></ca-icon>{{ 'GENERAL.UPLOAD_THUMBNAIL' | translate }}
                        <input
                            #uploadThumbSection
                            type="file"
                            accept="image/png, image/gif, image/jpeg"
                            data-uit="thumb-upload-input"
                            ng2FileSelect
                            [uploader]="uploaderThumb"
                            [multiple]="false"
                            hidden
                        />
                    </button>
                </div>

                <div class="my-2">
                    <ca-file-upload-progress
                        *ngIf="uploaderThumb?.queue?.length > 0"
                        [file]="uploaderThumb?.queue[0]"
                        [uploadProgress]="uploaderThumb?.queue[0]?.progress"
                    ></ca-file-upload-progress>

                    <div *ngIf="formGroup.get('thumbUrl')?.value" class="exist-item">
                        <span class="file-name">{{ formGroup.get('thumbUrl')?.value }}</span>
                        <button
                            type="button"
                            class="btn ca-btn-icon ca-btn-icon-small"
                            (click)="removeThumbFileItem()"
                            data-uit="publish-application-remove-thumb-btn"
                        >
                            <ca-icon name="cross" size="s"></ca-icon>
                        </button>
                    </div>
                </div>
            </div>

            <div>
                <div
                    caApeerFileUpload
                    data-uit="publish-application-file-upload"
                    [blobType]="blobType"
                    [maxInputSizeInBytes]="maxFileSizeInBytes"
                    [pathToAppend]="pathToAppend"
                    [supportedFileTypes]="supportedImageTypes"
                    [uploaderKey]="uploaderKey"
                    [errorNotificationMode]="'notification'"
                    (onUploadCompleted)="onUploadCompleted($event)"
                    (onUploadStarted)="onUploadStarted()"
                >
                    <button type="button" class="btn btn-secondary w-100 my-4" [disabled]="isUploading" (click)="uploadSection.click()">
                        <ca-icon name="upload" size="s"></ca-icon>{{ 'GENERAL.UPLOAD_IMAGES' | translate }}
                        <input
                            #uploadSection
                            type="file"
                            accept="image/png, image/gif, image/jpeg"
                            data-uit="image-upload-input"
                            ng2FileSelect
                            [uploader]="uploader"
                            [multiple]="multiple"
                            hidden
                        />
                    </button>
                </div>

                <div class="my-2">
                    <ca-file-upload-progress
                        *ngIf="uploader?.queue?.length > 0"
                        [file]="uploader?.queue[0]"
                        [uploadProgress]="uploader?.queue[0]?.progress"
                    ></ca-file-upload-progress>

                    <ng-container *ngFor="let formControl of imageUrls.controls; let i = index">
                        <div *ngIf="formControl" class="exist-item" #fileItem>
                            <span class="file-name">{{ formControl.value }}</span>
                            <button type="button" class="btn ca-btn-icon ca-btn-icon-small" (click)="removeFileItem(fileItem, i)">
                                <ca-icon name="cross" size="s"></ca-icon>
                            </button>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <div class="modal-buttons">
            <button type="submit" class="btn btn-primary w-100 mt-4" [disabled]="!formGroup.valid" data-uit="save-edited-application-btn">
                {{ 'GENERAL.SAVE' | translate }}
            </button>
        </div>
    </form>
</ca-modal-container>
